import { FiBarChart2, FiClock, FiCreditCard, FiFileText, FiGlobe, FiSmartphone } from 'react-icons/fi'
import './Features.css'
import { useTranslation } from 'react-i18next';

const Features = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: <FiFileText />,
      title: t('features.items.invoice.title'),
      description: t('features.items.invoice.description')
    },
    {
      icon: <FiClock />,
      title: t('features.items.timeTracking.title'),
      description: t('features.items.timeTracking.description')
    },
    {
      icon: <FiCreditCard />,
      title: t('features.items.payments.title'),
      description: t('features.items.payments.description')
    },
    {
      icon: <FiBarChart2 />,
      title: t('features.items.analytics.title'),
      description: t('features.items.analytics.description')
    },
    {
      icon: <FiGlobe />,
      title: t('features.items.multiCurrency.title'),
      description: t('features.items.multiCurrency.description')
    },
    {
      icon: <FiSmartphone />,
      title: t('features.items.mobileApp.title'),
      description: t('features.items.mobileApp.description')
    }
  ];

  return (
    <section className="features" id="features">
      <div className="container">
        <h2 className="section-title">{t('features.title')}</h2>
        <p className="section-subtitle">{t('features.subtitle')}</p>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="features-cta">
          <a href="/features" className="btn btn-secondary">
            {t('features.cta')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Features